import { render, staticRenderFns } from "./add-camera-box.vue?vue&type=template&id=39f1e0de&scoped=true&"
import script from "./add-camera-box.vue?vue&type=script&lang=js&"
export * from "./add-camera-box.vue?vue&type=script&lang=js&"
import style0 from "./add-camera-box.vue?vue&type=style&index=0&id=39f1e0de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1e0de",
  null
  
)

export default component.exports